export default {
  dailyCheck: {
    itself: 'Verificare zilnică',
    plural: {
      itself: 'Verificări zilnice',
    },
  },
};
